import { ViewColumn } from "@mui/icons-material";
import { MetaColsAll } from "stores/metadata/types";
import { FunctionComponent, useState } from "react";
import { isDefaultColProps } from "stores/metadata/utils/utils";
import MultiSelectorDialogBase2 from "../base/MultiSelectorDialogBase2";
import Chip from "./Chip";



interface Props {
	/** "name" delle proprietà selezionate */
	colNames: string[]
	onChange?: (colNamesSelected: string[]) => void
	sx?: any
}

const SelectorMetaColsH: FunctionComponent<Props> = ({
	colNames = [],
	onChange,
	sx,
}) => {

	// STORE


	// HOOKs
	const [isOpen, setIsOpen] = useState(false)


	// HANDLER
	const handleClick = () => {
		setIsOpen(true)
	}
	const handleClose = (colNamesSelected: string[]) => {
		setIsOpen(false)
		if (!!colNamesSelected) onChange?.(colNamesSelected)
	}
	const handleClear = (e) => {
		e.stopPropagation()
		setIsOpen(false)
		onChange?.(null)
	}


	// RENDER
	// se la lista delle colonne coincide con quella di default
	const isDefault = isDefaultColProps(colNames)
	// colNames == null || colNames.length == 0 
	// 	|| (colNames.length == MetaColsDefault.length && MetaColsDefault.every(col => colNames.includes(col.name)))

	const label = isDefault
		? "DEFAULT"
		: (colNames.length < 3
			? colNames.map(name => MetaColsAll.find(mc => mc.name == name)?.title).join(" ")
			: `+${colNames.length} COLS`
		)

	return (<>
		<Chip sx={sx}
			label={label}
			icon={<ViewColumn />}
			tooltip={"THE VISIBLE COLUMNS"}
			active={!isDefault}
			onClick={handleClick}
			onClear={handleClear}
		/>
		<MultiSelectorDialogBase2 noSpace
			maxWidth="xs"
			icon={<ViewColumn />}
			title={"SELECT COLUMNS TO DISPLAY"}

			items={MetaColsAll}
			itemsSelect={colNames}

			fnIdFromItem={(item) => item.name}
			fnTextFromItem={(item) => item.title}
			fnSecondaryFromItem={(item) => item.name}

			isOpen={isOpen}
			onClose={handleClose}
		/>
	</>)
}

export default SelectorMetaColsH

